import { IconSports } from "app/components/Icon/Icon";
import { ReportTypes } from "app/utils/const";
import cx from "classnames";
import React, { lazy, Suspense } from "react";
import { FormattedMessage } from "react-intl";
import "./ReportHeader.scss";

const OpenBetsHeaderTitle = lazy(
  () => import("../OpenBetsReportsDesktop/OpenBetsHeaderTitle")
);

type Props = {
  eventName: string;
  contentType: string;
  placedScore: string | null;
  betType?: string;
  sportName: string;
  marketName: string;
  runnerName: string;
  isUSPlayerProp?: boolean;
  submittedType?: string;
};

// Shows a header for each bet
// - Icon
// - Runner name
// - Event name

const ReportHeader: React.FC<Props> = ({
  contentType,
  eventName,
  placedScore,
  betType,
  sportName,
  marketName,
  runnerName,
  isUSPlayerProp,
  submittedType,
}) => {
  return (
    <div className="report__header">
      <div
        className={cx("report__header__icon", {
          "report__header__icon--green": contentType === ReportTypes.CURRENT,
        })}
      >
        <IconSports name={sportName} />
      </div>

      <div className="report__header__title">
        <Suspense fallback={<div className="fallback">loading...</div>}>
          <OpenBetsHeaderTitle
            eventName={eventName}
            marketName={marketName}
            runnerName={runnerName}
            isUSPlayerProp={isUSPlayerProp}
            betType={betType}
          />
          {betType === "MULTIPLIER" && placedScore && (
            <span className="open-bets-normal-item__col__placed-score">
              <span>
                <FormattedMessage tagName="span" id="reports-placed-at-score" />
                : {placedScore}
              </span>
            </span>
          )}
        </Suspense>
      </div>
    </div>
  );
};

export default ReportHeader;
